import { CITY_ACTION } from "./actionTypes";
export const CitiesStateSelectors = {
  list: state => state.cities[CITY_ACTION.LIST],
  view: state => state.cities[CITY_ACTION.VIEW],
  create: state => state.cities[CITY_ACTION.CREATE],
  update: state => state.cities[CITY_ACTION.UPDATE],
  searchList: state => state.cities[CITY_ACTION.SEARCH_LIST]
};